// import React from "react";
// import { useSelector } from "react-redux";
// import { RootState } from "../../../../store/store";

// const GaugeMeter: React.FC<{ value: number }> = ({
//   value,
//   //   noOfQuestion,
// }) => {
//   const clampedValue = Math.max(0, Math.min(value, 100));
//   const noOfQuestion = useSelector(
//     (state: RootState) => state.quizReducer.noOfQuestions
//   );
//   const correctQuestions = useSelector(
//     (state: RootState) => state.quizReducer.correctQuestions
//   );
//   //   const segments = [
//   //     { color: "#E5221E", min: 0, max: 20 }, // Red
//   //     { color: "#FE7400", min: 20, max: 40 }, // Orange
//   //     { color: "#FFBE00", min: 40, max: 60 }, // Yellow
//   //     { color: "#C8DC00", min: 60, max: 80 }, // Light green
//   //     { color: "#7CC325", min: 80, max: 100 }, // Green
//   //   ];

//   const baseColors = [
//     "#E5221E", // Red
//     "#FE7400", // Orange
//     "#FFBE00", // Yellow
//     "#C8DC00", // Light green
//     "#7CC325", // Green
//   ];

//   // Limit to 1–5 segments, and fall back to 5 if noOfQuestion is invalid
//   const segmentCount = Math.max(1, Math.min(noOfQuestion, 5));
//   const segmentSize = 100 / segmentCount;

//   const segments = Array.from({ length: segmentCount }, (_, i) => ({
//     color: baseColors[i],
//     min: i * segmentSize,
//     max: (i + 1) * segmentSize,
//   }));

//   const radius = 100;
//   const innerRadius = 30;
//   const centerX = 100;
//   const centerY = 100;
//   const needleWidth = 3;

//   // Convert a value (0–100) to angle (180° to 0°)
//   const valueToAngle = (val: number) => 180 - (val / 100) * 180;
//   const needleLength = 50;

//   // Get needle angle based on value
//   //   const needleAngle = clampedValue === 0 ? 179 : valueToAngle(clampedValue);
//   const needleAngle =
//     clampedValue === 0
//       ? 179
//       : clampedValue === 100
//       ? 1
//       : valueToAngle(clampedValue);

//   const needleRadians = (Math.PI / 180) * needleAngle;
//   const tipX = centerX + needleLength * Math.cos(needleRadians);
//   const tipY = centerY - needleLength * Math.sin(needleRadians);

//   // Offset perpendicular to the needle direction
//   const perpAngle = needleAngle + 90;
//   const offsetX = needleWidth * Math.cos((Math.PI / 180) * perpAngle);
//   const offsetY = -needleWidth * Math.sin((Math.PI / 180) * perpAngle);

//   // Converts polar to Cartesian
//   const polarToCartesian = (angle: number, r: number) => {
//     const rad = (Math.PI / 180) * angle;
//     return {
//       x: centerX + r * Math.cos(rad),
//       y: centerY - r * Math.sin(rad), // minus for SVG y-axis
//     };
//   };

//   // Describe an arc segment
//   const describeArc = (start: number, end: number) => {
//     const outerStart = polarToCartesian(start, radius);
//     const outerEnd = polarToCartesian(end, radius);
//     const innerEnd = polarToCartesian(end, innerRadius);
//     const innerStart = polarToCartesian(start, innerRadius);
//     const largeArcFlag = end - start <= 180 ? "0" : "1";

//     return [
//       `M ${outerStart.x} ${outerStart.y}`,
//       `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${outerEnd.x} ${outerEnd.y}`,
//       `L ${innerEnd.x} ${innerEnd.y}`,
//       `A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${innerStart.x} ${innerStart.y}`,
//       "Z",
//     ].join(" ");
//   };

//   return (
//     //     <svg width="200" height="120" viewBox="0 0 200 120">
//     //       {/* Draw segments */}
//     //       {segments.map((segment, i) => {
//     //         const startAngle = valueToAngle(segment.min);
//     //         const endAngle = valueToAngle(segment.max);
//     //         return (
//     //           <path
//     //             key={i}
//     //             d={describeArc(startAngle, endAngle)}
//     //             fill={segment.color}
//     //             stroke="#fff"
//     //             strokeWidth="1"
//     //           />
//     //         );
//     //       })}

//     //       {/* Needle */}
//     //       {/* <line
//     //         x1={centerX}
//     //         y1={centerY}
//     //         x2={centerX + needleLength * Math.cos(needleRadians)}
//     //         y2={centerY - needleLength * Math.sin(needleRadians)}
//     //         stroke="#333"
//     //         strokeWidth="4"
//     //         strokeLinecap="round"
//     //       /> */}
//     //       <polygon
//     //         points={`
//     //     ${centerX - 3} ${centerY},
//     //     ${centerX + 3} ${centerY},
//     //     ${centerX + needleLength * Math.cos(needleRadians)} ${
//     //           centerY - needleLength * Math.sin(needleRadians)
//     //         }
//     //   `}
//     //         fill="#333"
//     //       />

//     //       {/* Center circle */}
//     //       <circle cx={centerX} cy={centerY} r="6" fill="#333" />
//     //     </svg>
//     <div
//       style={{
//         width: "100%",
//         display: "flex",
//         justifyContent: "center",
//       }}
//     >
//       <svg
//         viewBox="0 0 200 120"
//         style={{
//           width: "100%",
//           maxWidth: "400px",
//           maxHeight: "250px",
//         }}
//       >
//         {/* Draw segments */}
//         {segments.map((segment, i) => {
//           const startAngle = valueToAngle(segment.min);
//           const endAngle = valueToAngle(segment.max);
//           return (
//             <path
//               key={i}
//               d={describeArc(startAngle, endAngle)}
//               fill={segment.color}
//               stroke="#fff"
//               strokeWidth="1"
//             />
//           );
//         })}

//         {/* Needle
//         <polygon
//           points={`
//       ${centerX - 5} ${centerY},
//       ${centerX + 5} ${centerY},
//       ${centerX + needleLength * Math.cos(needleRadians)} ${
//             centerY - needleLength * Math.sin(needleRadians)
//           }
//     `}
//           fill="#333"
//         /> */}
//         <polygon
//           points={`
//             ${centerX + offsetX},${centerY + offsetY}
//             ${centerX - offsetX},${centerY - offsetY}
//             ${tipX},${tipY}
//           `}
//           fill="#333"
//         />
//         {/* Center circle */}
//         <circle cx={100} cy={100} r="6" fill="#333" />
//       </svg>
//     </div>
//   );
// };

// export default GaugeMeter;

import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";

const GaugeMeter: React.FC<{ value: number }> = ({ value }) => {
  const noOfQuestion = useSelector(
    (state: RootState) => state.quizReducer.noOfQuestions,
  );
  const correctQuestions = useSelector(
    (state: RootState) => state.quizReducer.correctQuestions,
  );

  const clampedNoOfQuestion = Math.max(1, Math.min(noOfQuestion, 5));
  const segmentSize = 100 / clampedNoOfQuestion;

  // Always keep red as first and green as last
  const firstColor = "#E5221E"; // Red
  const lastColor = "#7CC325"; // Green
  const middleColors = [
    noOfQuestion === 3 ? "#FFBE00" : "#FE7400",
    "#FFBE00",
    "#C8DC00",
  ]; // Orange, Yellow, Light Green

  // Create color array for segments
  const segmentColors = [firstColor];
  for (let i = 1; i < clampedNoOfQuestion - 1; i++) {
    segmentColors.push(middleColors[i - 1]);
  }
  if (clampedNoOfQuestion > 1) {
    segmentColors.push(lastColor);
  }

  const segments = Array.from({ length: clampedNoOfQuestion }, (_, i) => ({
    color: segmentColors[i],
    min: i * segmentSize,
    max: (i + 1) * segmentSize,
  }));

  // Gauge settings
  const radius = 100;
  const innerRadius = 30;
  const centerX = 100;
  const centerY = 100;
  const needleWidth = 3;
  const needleLength = 50;

  // Convert a value (0–100) to angle (180° to 0°)
  const valueToAngle = (val: number) => 180 - (val / 100) * 180;

  // Position needle in center of correct segment (based on correctQuestions)
  //   const correctIndex = Math.max(
  //     0,
  //     Math.min(correctQuestions - 1, clampedNoOfQuestion - 1)
  //   );
  //   const needleValue =
  //     segments[correctIndex].min +
  //     (segments[correctIndex].max - segments[correctIndex].min) / 2;
  let needleValue = segmentSize / 2; // Default to middle of the first segment

  const clampedValue = Math.max(0, Math.min(value, 100));

  for (const seg of segments) {
    if (clampedValue >= seg.min && clampedValue <= seg.max) {
      needleValue = seg.min + (seg.max - seg.min) / 2;
      break;
    }
  }

  const needleAngle = valueToAngle(needleValue);
  const needleRadians = (Math.PI / 180) * needleAngle;
  const tipX = centerX + needleLength * Math.cos(needleRadians);
  const tipY = centerY - needleLength * Math.sin(needleRadians);

  const perpAngle = needleAngle + 90;
  const offsetX = needleWidth * Math.cos((Math.PI / 180) * perpAngle);
  const offsetY = -needleWidth * Math.sin((Math.PI / 180) * perpAngle);

  const polarToCartesian = (angle: number, r: number) => {
    const rad = (Math.PI / 180) * angle;
    return {
      x: centerX + r * Math.cos(rad),
      y: centerY - r * Math.sin(rad),
    };
  };

  const describeArc = (start: number, end: number) => {
    const outerStart = polarToCartesian(start, radius);
    const outerEnd = polarToCartesian(end, radius);
    const innerEnd = polarToCartesian(end, innerRadius);
    const innerStart = polarToCartesian(start, innerRadius);
    const largeArcFlag = end - start <= 180 ? "0" : "1";

    return [
      `M ${outerStart.x} ${outerStart.y}`,
      `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${outerEnd.x} ${outerEnd.y}`,
      `L ${innerEnd.x} ${innerEnd.y}`,
      `A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${innerStart.x} ${innerStart.y}`,
      "Z",
    ].join(" ");
  };

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <svg
        viewBox="0 0 200 120"
        style={{ width: "100%", maxWidth: "400px", maxHeight: "250px" }}
      >
        {segments.map((segment, i) => {
          const startAngle = valueToAngle(segment.min);
          const endAngle = valueToAngle(segment.max);
          return (
            <path
              key={i}
              d={describeArc(startAngle, endAngle)}
              fill={segment.color}
              stroke="#fff"
              strokeWidth="1"
            />
          );
        })}

        <polygon
          points={`
            ${centerX + offsetX},${centerY + offsetY}
            ${centerX - offsetX},${centerY - offsetY}
            ${tipX},${tipY}
          `}
          fill="#333"
        />
        <circle cx={centerX} cy={centerY} r="6" fill="#333" />
      </svg>
    </div>
  );
};

export default GaugeMeter;
